export type ContractPdf = {
  contentBase64: string;
  contentType: string;
  filename: string;
};

function decodeBase64(contentBase64: string): ArrayBuffer {
  try {
    const binary = atob(contentBase64);
    const bytes = new Uint8Array(binary.length);
    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }
    return bytes.buffer;
  } catch {
    throw new Error("The travel agreement file could not be downloaded.");
  }
}

export function saveContractPdf({
  contentBase64,
  contentType,
  filename,
}: ContractPdf): void {
  const url = URL.createObjectURL(
    new Blob([decodeBase64(contentBase64)], { type: contentType }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
